/**
 * Page hero — image zoom + gradient reveal.
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';
import { prefersReducedMotion } from './camst-counter.js';

gsap.registerPlugin(ScrollTrigger);

var heroInstances = new WeakMap();

export function initCamstPageHero(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-page-hero]'));
  } else if (scope.matches && scope.matches('[data-camst-page-hero]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-page-hero]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstPageHeroInit === '1') {
      return;
    }

    root.dataset.camstPageHeroInit = '1';
    initCamstReveal(root);

    if (prefersReducedMotion()) {
      return;
    }

    var image = root.querySelector('[data-camst-page-hero-image]');
    var gradient = root.querySelector('[data-camst-page-hero-gradient]');

    var ctx = gsap.context(function () {
      if (image) {
        gsap.to(image, {
          scale: 1.4,
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });
      }

      if (gradient) {
        gsap.fromTo(
          gradient,
          { opacity: 0 },
          {
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: root,
              start: 'top top',
              end: 'bottom center',
              scrub: true,
            },
          }
        );
      }
    }, root);

    heroInstances.set(root, ctx);
  });
}

export function teardownCamstPageHero(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-page-hero]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-page-hero]'));

  roots.forEach(function (root) {
    var ctx = heroInstances.get(root);

    if (ctx) {
      ctx.revert();
      heroInstances.delete(root);
    }

    teardownCamstReveal(root);
    delete root.dataset.camstPageHeroInit;
  });
}
